import { createFileRoute, useRouter } from '@tanstack/react-router'
import { FocusModeView } from '../../../../screens/focus/FocusModeView'
import { useGetTask, useUpdateTask, type Task } from '@zendia/frontend-shared'
import { axiosRequest } from '../../../../utilities/axiosClient'

export const Route = createFileRoute('/_authenticated/tasks/$taskId/focus')({
  component: RouteComponent,
  staticData: { suppressNotifications: true },
})

function RouteComponent() {
  const router = useRouter()
  const { taskId } = Route.useParams()
  const { data: task, isLoading: tasksLoading } = useGetTask(axiosRequest, taskId)
  const { mutateAsync: updateTask } = useUpdateTask(axiosRequest)

  const handleClose = () => {
    if (router.history.canGoBack()) {
      router.history.back()
    } else {
      router.history.replace('/dashboard')
    }
  }

  const handleStop = async (elapsedSeconds: number) => {
    if (!task) return
    try {
      await updateTask({
        taskId: task.id,
        data: { actualDuration: elapsedSeconds } as Partial<Task>,
      })
    } catch (error) {
      console.error('Error saving focus duration:', error)
    }
  }

  return tasksLoading ? (
    <div>Loading...</div>
  ) : (
    <FocusModeView task={task} onClose={handleClose} onStop={handleStop} />
  )
}
